"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCalculateRates = void 0;
const smap_1 = require("../smap");
const State_1 = require("../typeDefs/State");
const values_1 = __importDefault(require("../values"));
const bigmath_1 = require("../bigmath");
function useCalculateRates(state, itemFilter) {
    const effectiveProductionRates = {};
    const maxConsumptionRates = {};
    const effectiveConsumptionRates = {};
    function addToMaxRate(ingredient, rate) {
        if (maxConsumptionRates[ingredient] === undefined) {
            maxConsumptionRates[ingredient] = 0n;
        }
        maxConsumptionRates[ingredient] += rate;
    }
    /**
     * [what's being consumed][the building]
     */
    const powerConsumptionRates = {};
    const { assemblers, disabledRecipes, productionState } = state;
    function assemblerStuck(itemName, assembler) {
        return ((productionState[itemName] ?? {})[assembler] ===
            State_1.PRODUCTION_OUTPUT_BLOCKED);
    }
    function assemblerIsStuckOrDisabled(itemName, assembler) {
        if (disabledRecipes[itemName])
            return "disabled";
        if (assemblerStuck(itemName, assembler))
            return "full";
        return false;
    }
    const assemblerBoosts = (0, smap_1.fromPairs)(values_1.default.allAssemblers.map((assemblerName) => [
        assemblerName,
        values_1.default.calculateBoost(assemblerName, state)
    ]));
    function getBoost(item) {
        return assemblerBoosts[item] ?? 1;
    }
    itemFilter.forEach((itemName) => {
        const production = {};
        effectiveProductionRates[itemName] = production;
        (0, smap_1.mapPairs)(values_1.default.byproductRatesPerSecond[itemName], (rate, producer) => {
            const speeds = (0, smap_1.mapPairs)(assemblers[producer], (assemblerNumber, assemblerName) => producer != itemName && disabledRecipes[producer]
                ? 0n
                : (0, bigmath_1.scaleBigInt)(assemblerNumber, values_1.default.assemblerSpeeds[assemblerName] *
                    getBoost(assemblerName) *
                    rate));
            production[producer] = (0, bigmath_1.bigSum)(speeds);
        });
        if (values_1.default.sideProducts[itemName].length === 0) {
            const assemblersMakingThis = assemblers[itemName] ?? {};
            const baseCraftTime = values_1.default.timePerRecipe[itemName];
            (0, smap_1.mapPairs)(assemblersMakingThis, (assemblerCount, assemblerName) => {
                const speed = (0, bigmath_1.scaleBigInt)(assemblerCount, values_1.default.assemblerSpeeds[assemblerName] *
                    getBoost(assemblerName) / baseCraftTime);
                production[assemblerName] = speed;
            });
        }
    });
    function addAssemblerPowerConsumption(assemblerName, count, recipeName) {
        const power = values_1.default.buildingPowerRequirementsPerSecond[assemblerName];
        const counted = !assemblerIsStuckOrDisabled(recipeName, assemblerName);
        (0, smap_1.mapPairs)(power, (requiredCount, ingredient) => {
            (powerConsumptionRates[ingredient] ??= {})[assemblerName] ??= [
                0n, 0n, 0n,
            ];
            const k = powerConsumptionRates[ingredient][assemblerName];
            const q = (0, bigmath_1.bigMul)(requiredCount, count);
            addToMaxRate(ingredient, q);
            k[1] += count;
            if (counted) {
                k[0] += count;
                k[2] += q;
            }
        });
    }
    (0, smap_1.keys)(assemblers).forEach((itemName) => {
        (0, smap_1.mapPairs)(assemblers[itemName], (assemblerCount, assemblerName) => {
            addAssemblerPowerConsumption(assemblerName, assemblerCount, itemName);
        });
        if (disabledRecipes[itemName])
            return;
        const recipe = values_1.default.recipes[itemName];
        const baseCraftTime = values_1.default.timePerRecipe[itemName];
        (0, smap_1.mapPairs)(recipe, (count, ingredient) => {
            let rate = 0;
            let maxRate = 0;
            (0, smap_1.mapPairs)(assemblers[itemName], (assemblerCount, assemblerName) => {
                const subRate = (0, bigmath_1.bigToNum)(assemblerCount) * (values_1.default.assemblerSpeeds[assemblerName] *
                    getBoost(assemblerName) / baseCraftTime);
                maxRate += subRate;
                if (assemblerIsStuckOrDisabled(itemName, assemblerName))
                    return;
                rate += subRate;
            });
            addToMaxRate(ingredient, (0, bigmath_1.scaleBigInt)(count, maxRate));
            (effectiveConsumptionRates[ingredient] ??= {})[itemName] = (0, bigmath_1.scaleBigInt)(count, rate);
        });
    });
    return {
        effectiveConsumptionRates,
        effectiveProductionRates,
        powerConsumptionRates,
        maxConsumptionRates,
        assemblerIsStuckOrDisabled,
    };
}
exports.useCalculateRates = useCalculateRates;
